const config = {
  rowSelection: true,
  columns: [
    {
      title: '收款单号',
      dataIndex: 'transactionCode',
      width: 190,
      ellipsis: true,
    },
    {
      title: '支付方式',
      dataIndex: 'paymentMethodName',
      width: 150
    },
    {
      title: '收款金额',
      dataIndex: 'amount',
      width: 140,
    },
    {
      title: '确认收款操作时间',
      dataIndex: 'receivedClickDate',
      itemType: 'dateTime',
      width: 160
    },
    {
      title: '收款状态',
      dataIndex: 'stateName',
      width: 120
    },
    {
      title: '交易类型',
      dataIndex: 'transactionTypeName',
      width: 120
    },
    {
      title: '备注',
      dataIndex: 'description',
      width: 200,
      ellipsis: true,
    },
    {
      title: '操作',
      dataIndex: '#',
      width: 240,
      render: 'renderOperate',
      fixed: 'right'
    },
  ],
  footer: [
    {
      label: '收款计算',
      auth: 'orderCollectionCountAuth',
      events: ['onClick:onCollectionCount'],
    },
  ],
}

export default config
